import { render, staticRenderFns } from "./HospitalColumn.vue?vue&type=template&id=413dc004"
import script from "./HospitalColumn.vue?vue&type=script&lang=js"
export * from "./HospitalColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports